import PropTypes from 'prop-types';

export const Props = {
  onCloseDialog: PropTypes.func.isRequired,
};

export const DefaultProps = {};
